module.exports = require("core-js-pure/features/instance/concat");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/instance/concat.js
// module id = 473
// module chunks = 13